// "This constellation": the one surrounding the planet an alignment belongs
// to, for the rules that speak of it (Majesty, Capability, Sacrifice,
// Transformation).
import type { AlignmentId } from '../catalogue';
import type { AlignmentContext } from '../types';

/** The index of the constellation surrounding the planet with this alignment, or -1. */
export function ownIndex(ctx: AlignmentContext, id: AlignmentId): number {
  for (const a of ctx.active.values()) if (a.alignment === id) return a.index;
  return -1;
}
